import { useSyncExternalStore } from 'react';
import { useStreamStatus } from '~/api/ApiProvider';

function subscribe(cb: () => void) {
  window.addEventListener('online', cb);
  window.addEventListener('offline', cb);
  return () => {
    window.removeEventListener('online', cb);
    window.removeEventListener('offline', cb);
  };
}

export function useOnline(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => navigator.onLine,
    () => true,
  );
}

/**
 * A thin bar at the top when the browser is offline or live updates dropped. It says what still
 * works; it never blocks the screen.
 */
export function OfflineBanner() {
  const online = useOnline();
  const stream = useStreamStatus();
  if (online && stream !== 'reconnecting') return null;
  return (
    <div role="status" className="fixed inset-x-0 top-0 z-50 flex justify-center px-4 pt-2">
      <span className="rounded-lg border border-gold bg-gold-tint px-3.5 py-1.5 text-13 font-semibold text-gold-ink shadow-card">
        {online
          ? 'Live updates paused. Reconnecting; anything that changed meanwhile will appear.'
          : 'You’re offline. What’s on screen stays; Workspace catches up when the connection is back.'}
      </span>
    </div>
  );
}
